import { useContext } from 'react';
import { useNavigate } from 'react-router';

import { TELEGRAM_GROUP_LINK } from 'const';
import { MobileContext } from 'context';
import { ReactComponent as BackArrow } from 'assets/icons/LeftArrowFat.svg';
import './styles.scss';


export const telegramGroupHyperlink = (
  <a href={TELEGRAM_GROUP_LINK} target='_blank' rel='noopener noreferrer'>
    Telegram group
  </a>
);

export const unixTimestampHyperlink = (<span className='LongURLWrapper'>
  <a
    href='https://www.unixtimestamp.com'
    target='_blank' rel='noopener noreferrer'
  >
    https://www.unixtimestamp.com
  </a>
</span>);


export function BackButton() {
  const { isMobile } = useContext(MobileContext);
  const navigate = useNavigate();

  return (<button
    className={'SimpleBackButton' + (isMobile ? ' Mobile' : '')}
    onClick={() => navigate(-1)}
  >
    <BackArrow />
  </button>);
}
